import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import cn from 'classnames';

import Counter from './liveMenuCounter';
import League from './liveMenuLeague';
import Other from './liveMenuOther';
import FavouriteStar from '../favouriteStar';


@withRouter
@inject('lineStore', 'routingStore')
@observer
class LiveMenuSport extends Component {
  static childContextTypes = {
    sportId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  }

  constructor(props) {
    super(props);
  }

  getChildContext() {
    return { sportId: this.props.id };
  }

  selectItem = (evt) => {
    // this.props.routingStore.push(`/${this.props.lineStore.menu.mode}/${this.props.id}`);
    this.props.history.push(`/${this.props.lineStore.menu.mode}/${this.props.id}`);
    // this.props.history.push(this.props.id, this.props.type);
    this.toggle();
    evt.preventDefault();
  }

  toggle = () => {
    this.props.lineStore.menu.toggleOpenItem(this.props.id, this.props.type);
  }

  getCount() {
    const arrLeague = this.props.lineStore.menu.sport.get(this.props.id).league;
    let count = 0;
    for (const id of arrLeague) {
      if (this.props.lineStore.menu.league.has(id)) {
        count += this.props.lineStore.menu.league.get(id).games.length;
      }
    }
    return count;
  }

  render() {
    const { id, type } = this.props;

    if (id === 'other') {
      return (
        <Other />
      )
    }

    const { sport, selected, isOpen } = this.props.lineStore.menu;
    const data = sport.get(id);
    const select = selected.sport.includes(id);
    const isOpenedSport = isOpen.sport.includes(id);

    if (!data) {
      return null;
    }

    return (
      <a className={cn(['favourites-sport-item', { 'favourites-item_active': select }])}>
        <FavouriteStar
          type={type}
          id={id}
        />
        <button
          className={`favourites-sport-item-toggle f-i-t ${isOpenedSport ? 'f-i-t-a' : ''}`}
          onClick={this.toggle}
        >
          <div>
            <span className="f-s-ico-arrow_buttom_1" />
          </div>
        </button>
        <button
          className={cn(['favourites-item-load f-i-l', `f-s-i-a-${id}`])}
          onClick={this.selectItem}
        >
          <span className={`line-sport-menu-item-ico f-s-ico-${id}`} />
          <Counter count={this.getCount()} />
          <div className="favourites-item-load-label">{data.name}</div>
        </button>
        {isOpenedSport && (
          <div className="favourites-league-wrapper">
            {data.league.map(o => (
              <League
                parentIsOpen={isOpenedSport}
                id={o}
                key={o}
                type={2}
              />
            ))}
          </div>
        )}
      </a>
    );
  }
}

export default LiveMenuSport;


// WEBPACK FOOTER //
// ./src/components/liveMenu/liveMenuSport.jsx